<script setup lang="ts">
import { onUnmounted } from 'vue'
import { useMyStore } from './stores/mystore'
import NotesList from './components/NotesList.vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

// Cleanup price store when app unmounts
onUnmounted(() => {
  const myStore=useMyStore();
  myStore.cleanup();
})

const myStore = useMyStore()
</script>

<template>
  <div id="appDiv" class="h-dvh  w-full max-h-dvh ">
    <RouterView />

    <!-- Notes Drawer (Headless UI) -->
    <TransitionRoot as="template" :show="myStore.notesDrawerOpen">
      <Dialog class="relative z-50" @close="myStore.closeNotesDrawer()">
        <div class="fixed inset-0 bg-black/40" />

        <div class="fixed inset-0 overflow-hidden">
          <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
              <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                <DialogPanel class="pointer-events-auto w-screen max-w-2xl">
                  <div class="relative flex h-full flex-col overflow-hidden bg-white py-6 shadow-xl">
                    <div class="px-4 sm:px-6">
                      <div class="flex items-start justify-between">
                        <DialogTitle class="text-base font-semibold text-gray-900">Notes</DialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <button type="button" class="relative rounded-md text-gray-400 hover:text-gray-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" @click="myStore.closeNotesDrawer()">
                            <span class="absolute -inset-2.5" />
                            <span class="sr-only">Close panel</span>
                            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="relative mt-6 flex-1 px-4 sm:px-6 min-h-0 overflow-hidden">
                      <NotesList />
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
